import React from "react";

export default function StatusBadge({ status }) {
  const map = {
    lunas: {
      bg: "rgba(30, 86, 49, 0.12)",
      color: "#1E5631",
      border: "rgba(30, 86, 49, 0.4)",
      glow: "rgba(30, 86, 49, 0.2)",
      text: "Lunas"
    },
    menunggu: {
      bg: "rgba(245, 158, 11, 0.12)",
      color: "#B45309",
      border: "rgba(245, 158, 11, 0.4)",
      glow: "rgba(245, 158, 11, 0.2)",
      text: "Menunggu verifikasi"
    },
    "menunggu verifikasi": {
      bg: "rgba(245, 158, 11, 0.12)",
      color: "#B45309",
      border: "rgba(245, 158, 11, 0.4)",
      glow: "rgba(245, 158, 11, 0.2)",
      text: "Menunggu verifikasi"
    },
    "sudah verifikasi": {
      bg: "rgba(30, 86, 49, 0.12)",
      color: "#1E5631",
      border: "rgba(30, 86, 49, 0.4)",
      glow: "rgba(30, 86, 49, 0.2)",
      text: "Sudah verifikasi"
    },
    pending: {
      bg: "rgba(245, 158, 11, 0.12)",
      color: "#B45309",
      border: "rgba(245, 158, 11, 0.4)",
      glow: "rgba(245, 158, 11, 0.2)",
      text: "Menunggu verifikasi"
    },
    belum: {
      bg: "rgba(194, 76, 76, 0.12)",
      color: "#C24C4C",
      border: "rgba(194, 76, 76, 0.4)",
      glow: "rgba(194, 76, 76, 0.2)",
      text: "Belum bayar"
    }
  };

  const s =
    map[(status || "").toLowerCase()] || {
      bg: "rgba(245, 158, 11, 0.12)",
      color: "#B45309",
      border: "rgba(245, 158, 11, 0.4)",
      glow: "rgba(245, 158, 11, 0.2)",
      text: status
    };

  return (
    <span
      style={{
        display: "inline-block",
        fontSize: "12.5px",
        fontWeight: "700",
        letterSpacing: "0.3px",
        color: s.color,
        background: s.bg,
        border: `1px solid ${s.border}`,
        padding: "5px 14px",
        borderRadius: "20px",
        boxShadow: `0 0 12px ${s.glow}`,
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)"
      }}
    >
      {s.text}
    </span>
  );
}